import React from "react";
import { Button } from "reactstrap";

import { Loader } from "../Loader";

const CustomButton = (props) => {
    const {
        className = "",
        loaderColor = "light",
        title,
        outline = false,
        loading = false,
        color,
        onClick,
        type,
        disabled,
        name,
        img,
        imgClassname = ""
    } = props;
    return (
        <Button
            name={name}
            disabled={disabled}
            type={type}
            color={color}
            onClick={onClick}
            outline={outline}
            className={`custom-btn ${className} ${outline && "btn-outline-primary"}`}
        >
            {loading ? (
                <Loader size={"sm"} color={loaderColor} />
            ) : (
                <div className="btn-title-container d-flex justify-content-center align-items-center">
                    {img && <img className={`btn-icon ${imgClassname}`} src={img} />}
                    {title}
                </div>
            )}
        </Button>
    );
};

export default CustomButton;
